/**
 * UnTrap for YouTube — Shorts blocker / recommendation remover
 *
 * Declares three web-accessible-resource groups. Two are scoped to YouTube origins
 * (the injected quality/skip scripts and the blocking iframes), so they are unreachable
 * from an arbitrary page. Only one group is matched to every origin, and it holds a
 * single file: popup/screens/privacyPolicy/privacyPolicyForTab.js. With no
 * use_dynamic_url it sits at a fixed URL, so a fetch of it from any page is conclusive.
 *
 * Manifest verified against version 9.9.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'enboaomnljigfhfjfoalacienlhjlfil';

export const untrapForYouTube: ExtensionDefinition = {
  id: ID,
  name: 'UnTrap for YouTube — Block Shorts, Remove Recommendations, Detox & Focus',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Most WAR are YouTube-scoped; the only one exposed to every origin is ' +
    'privacyPolicyForTab.js, a static path. That single fetch is conclusive.',
  signals: [
    {
      id: 'war-privacy-policy-tab-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch popup/screens/privacyPolicy/privacyPolicyForTab.js — the one resource ' +
        'exposed to every origin at a fixed URL, so it is reachable from any page.',
      weight: 1,
      run: () => probeFetch(ID, 'popup/screens/privacyPolicy/privacyPolicyForTab.js'),
    },
  ],
};
